
































import { Component, Vue } from 'vue-property-decorator';
import TitleBar from '@/components/layout/TitleBar.vue';
import BoxTile from '@/components/ui/BoxTile.vue';
import {SET_UNIT} from "@/store";
import WeightLabel from '@/components/ui/WeightLabel.vue';
import AgeLabel from '@/components/ui/AgeLabel.vue';

@Component({
  components: {
    AgeLabel,
    WeightLabel,
    BoxTile,
    TitleBar
  },
})
export default class DashboardHome extends Vue {

  private redirectedToGoal = false;

  get lastAgeInMonths() {
    if (this.$store.state.data && this.$store.state.data.base_info)
      return this.$store.state.data.base_info.last_age_months
    else return 0;
  }
  get lastAgeInWeeks() {
    if (this.$store.state.data && this.$store.state.data.base_info)
      return this.$store.state.data.base_info.last_age_weeks
    else return 0;
  }

  get latestGoal() {
    if (this.$store.state.data) {
      if (this.$store.state.data.goals && this.$store.state.data.goals.length) {
        return this.$store.state.data.goals[0].goalKey
      }
      return 'latest';
    }
    return 'latest';
  }

  get currentAgeInMonths() {
    if (this.$store.state.data && this.$store.state.data.base_info)
      return this.$store.state.data.base_info.current_age_months
    else return 0;
  }
  get currentAgeInWeeks() {
    if (this.$store.state.data && this.$store.state.data.base_info)
      return this.$store.state.data.base_info.current_age_weeks
    else return 0;
  }

  public setUnit(unit: string) {
    this.$store.commit(SET_UNIT, unit);
  }

  private created() {
    const storage = window.localStorage;
    if (!storage.getItem('SEEN_WELCOME')) {
      this.$router.push({name: 'dashboard.welcome'});
    }
    else {
      const storageRedirect = window.sessionStorage;
      if (!storageRedirect.getItem('REDIRECTED_TO_GOAL_' + this.$store.state.data.website_id)) {
        this.$router.push({name: 'dashboard.goals', params: {id: this.latestGoal}});
        storageRedirect.setItem('REDIRECTED_TO_GOAL_' + this.$store.state.data.website_id, '1');
      }
      else {
        // this.$ga.page(this.$route.fullPath)
      }
    }
  }
}
